import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import { Circle, LineString, Point, Polygon } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import * as olProj from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';
import Icon from 'ol/style/Icon';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import { getArea, getLength } from "ol/sphere";
import jspdf from 'jspdf';
import { OtherService } from './other.service';
import axios from './axios';
import { GurdServiceService } from './gurd-service.service';
declare let $: any;

@Injectable({

  providedIn: 'root',

})

export class MapService { 

  polyganData: any;

  constructor(private otherService: OtherService, private gurdService: GurdServiceService) { }

  createMarker(position: any, icon: any, id = '', name = '', data = {}) {
    let coord4326 = olProj.transform(position, 'EPSG:4326', 'EPSG:3857');

    let feature = new Feature({
      type: 'removable',
      geometry: new Point(coord4326),
      data: data,
    });
    var layerImage = new Icon({
      src: icon,
      anchor: [0.1, 45],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
    });

    let pinLayer = new VectorLayer({
      source: new VectorSource({
        features: [feature],
      }),
      id: id,
      name: name,
      style: new Style({
        image: layerImage,
      }),
    } as any);
    return pinLayer;
  }

  transformCoordinates(coordinates: any) {
    return olProj.transform(coordinates, 'EPSG:3857', 'EPSG:4326');
  }

  transformCoordinates2(coordinates: any) {
    return olProj.transform(coordinates, 'EPSG:4326', 'EPSG:3857');
  }

  mapPointerMove(pixels: any, map: any) {
    var featureLayer = map.forEachFeatureAtPixel(
      pixels,
      function (feature: any, layer: any) {
        return { feature: feature, layer: layer };
      }
    );
    var data = {
      featureLayer: featureLayer,
      pixel: pixels,
    };
    return data;
  }

  drawRoute(
    routeId: any,
    map: any,
    coordinates: any,
    data: any,
    // origCoordinates:any,
    hasRandomcolorLine = false
  ) {
    var color = Math.floor(Math.random() * 16777215).toString(16);

    var startMarker = this.createMarker(
      [coordinates[0].longitude, coordinates[0].latitude],
      "../../assets/Img/marker4.png",
      `${routeId}_start`,
      `route_start`
    );
    var lastCoordinate = coordinates[coordinates.length - 1];
    var endMarker = this.createMarker(
      [lastCoordinate.longitude, lastCoordinate.latitude],
      "../../assets/Img/marker5.png",
      `${routeId}_end`,
      `route_end`,
      {
        html: `<a href="/carInfo/${data.strUnitId}" target='_blank'>
              <h5 class='text-dark'>${data.strFullName} (${data.strMobileType_strComment}) </h5>
              <hr class='text-dark m-1' />
              <div class='justify-content-end d-flex align-items-center'>
                <span class=" text-secondary ms-1"> ${data.fKm} کیلو متر</span>
              <i class="fa fa-user-circle text-secondary "></i>
              </div>
              <div class='justify-content-end d-flex align-items-center'>
              <span class=" text-secondary ms-1">${data.strVehicleNo}</span>
            <i class="fa fa-user-circle text-secondary "></i>
            </div>
            <div class='justify-content-end d-flex align-items-center'>
            <span class=" text-secondary ms-1">${data.strTime}</span>
          <i class="fa fa-user-circle text-secondary "></i>
          </div>
          <div class='justify-content-end d-flex align-items-center'>
          <span class=" text-secondary ms-1">${data.strDate}</span>
        <i class="fa fa-user-circle text-secondary "></i>
        </div>
        <div class='justify-content-end d-flex align-items-center'>
        <span class=" text-secondary ms-1">${data.bonline == true ? data.bonline = 'روشن' : data.bonline = 'خاموش'}</span>
      <i class="fa fa-user-circle text-secondary "></i>
      </div>
      <div class='justify-content-end d-flex align-items-center'>
      <span class=" text-secondary ms-1">${data.bACC == true ? data.bACC = 'باز' : data.bACC = 'بسته'}</span>
    <i class="fa fa-user-circle text-secondary "></i>
    </div>
        </a>`,
      }
    );

    var points = [];
    var pointFeatures = [];

    // var origPoints = [];
    // for (const point of origCoordinates) {
    //   let coord4326 = olProj.transform(
    //     [point.longitude, point.latitude],
    //     "EPSG:4326",
    //     "EPSG:3857"
    //   );
    //   origPoints.push([coord4326[0], coord4326[1]]);
    // }

    for (const point of coordinates) {
      let coord4326 = olProj.transform(
        [point.longitude, point.latitude],
        "EPSG:4326",
        "EPSG:3857"
      );
      points.push([coord4326[0], coord4326[1]]);
      var f = new Feature({
        geometry: new Circle([coord4326[0], coord4326[1]], 0.5),
        data: point.tooltipContent,
        name: "route_point",
      });

      f.setStyle(
        new Style({
          fill: new Fill({
            color: !hasRandomcolorLine ? "#1010fd" : `#${color}`,
          }),
        })
      );
      pointFeatures.push(f);
    }
    var line = new LineString(points);
    //var line2 = new LineString(origPoints);

    var length = getLength(line);
    var style = new Style({
      stroke: new Stroke({
        color: !hasRandomcolorLine ? "#0000ff" : `#${color}`,
        width: 1,
      }),
      // strokeColor: '#0000ff',
      // strokeOpacity: 0.7,
      // strokeWidth: 10
    });
    var lineFeature = new Feature({
      geometry: line,
      //style: style
    });
    lineFeature.setStyle(style);

    var lineLayer = new VectorLayer({
      source: new VectorSource({
        features: [lineFeature, ...pointFeatures],
      }),
      id: routeId,
      name: "route_line",
    } as any);
    map.addLayer(startMarker);
    map.addLayer(lineLayer);
    map.addLayer(endMarker);

    return { l1: length };
  }

  //? ترسیم ایکن خودرو توسط 'مقدار' ارسالی از سرور

  drawRouteAnimate(routeId: any, map: any, coordinates: any, data: any, hasRandomcolorLine: boolean = false, isLivePoint?: boolean, drawLine: boolean = true) {

    var color = Math.floor(Math.random() * 16777215).toString(16);

    var startMarker;

    var lastCoordinate = coordinates[coordinates.length - 1];

    var endMarker;

    if (!isLivePoint) {

      startMarker = this.createMarker([coordinates[0].fLon, coordinates[0].fLat],

        "../../assets/Img/marker4.png",

        `${routeId}_start`,

        `route_start`

      );

      this.removeLayerByName('route_end', map);

      map.getView().setCenter(olProj.fromLonLat([lastCoordinate.fLon, lastCoordinate.fLat]));

      endMarker = this.craeteArrow([lastCoordinate.fLon, lastCoordinate.fLat],

        "../../assets/Img/download.png",

        `${routeId}_end`,

        `route_end`,

        {
          html: `

             <span class="text-success"> تاریخ : ${lastCoordinate.strDate}</span>

             <br />

             <span class="text-success">زمان : ${lastCoordinate.strTime}</span>

             <br />

             <span class="text-danger">سرعت : ${lastCoordinate.iSpeed}</span>

             `,

          html2: `<span class="text-success">${lastCoordinate.carName}</span>

             `,
        },

        lastCoordinate.iAngle

      );

    }

    //? ترسیم ایکن خودرو توسط 'نام فایل' ارسالی از سرور

    else {

      if (data.strIconName) {

        startMarker = this.createMarker(

          [coordinates[0].fLon, coordinates[0].fLat],

          `../../../assets/mobile-icons/${data.strIconName}`,

          `${routeId}_start`,

          `route_start`

        );

      }

      else {

        if (data.Status == 0) {

          startMarker = this.createMarker(

            [coordinates[0].fLon, coordinates[0].fLat],

            "../../assets/Img/redcarMarker.png",

            `${routeId}_start`,

            `route_start`

          );

        }

        else {

          startMarker = this.createMarker(

            [coordinates[0].fLon, coordinates[0].fLat],

            "../../assets/Img/cargreenMarker.png",

            `${routeId}_start`,

            `route_start`

          );

        }

      }

      endMarker = this.craeteArrowTxt(

        [lastCoordinate.fLon, lastCoordinate.fLat],

        `${routeId}_end`,

        `route_end`,

        {
          html: `

             <span class="text-danger">زمان : ${lastCoordinate.strTime}</span>

             <br />

             <span class="text-danger">سرعت : ${lastCoordinate.iSpeed}</span>

             <br />

             <span class="text-black">حوزه خدمت : ${lastCoordinate.strMobileDomain}</span>

             <br />

             <span class="text-black">نوع خودرو : ${lastCoordinate.strMobileType}</span>`,

          html2: `<span class="text-success">${lastCoordinate.carName}</span>`,

        },

        lastCoordinate.carName

      );

    }

    // ترسیم مسیر

    // if (isLivePoint) return;

    var points = [];

    var pointFeatures = [];

    for (const point of coordinates) {

      let coord4326 = olProj.transform(

        [point.fLon, point.fLat],

        "EPSG:4326",

        "EPSG:3857"
      );

      points.push([coord4326[0], coord4326[1]]);

      var f = new Feature({

        geometry: new Circle([coord4326[0], coord4326[1]], 0),

        data: point.tooltipContent,

        name: "route_point",

      });

      f.setStyle(

        new Style({

          fill: new Fill({

            color: !hasRandomcolorLine ? "#1010fd" : `#${color}`,

          }),

        })

      );

      pointFeatures.push(f);

    }

    if (drawLine) {

      var line = new LineString(points);

      var length = getLength(line);

      var style = new Style({

        stroke: new Stroke({

          color: !hasRandomcolorLine ? "#0000ff" : `#${color}`,

          width: 3,

        }),

      });

      var lineFeature = new Feature({

        geometry: line,

        //style: style

      });

      lineFeature.setStyle(style);

      var lineLayer = new VectorLayer({

        source: new VectorSource({

          features: [lineFeature, ...pointFeatures],

        }),

        id: routeId,

        name: "route_line",

      } as any);

      map.addLayer(lineLayer);

    }

    map.addLayer(startMarker);

    map.addLayer(endMarker);

    return { l1: length || 0 };

  }

  //? ترسیم ایکن خودرو توسط 'نام فایل' ارسالی از سرور

  drawRouteAnimate_New(routeId: any, map: any, coordinates: any, data: any) {

    var startMarker;

    var lastCoordinate = coordinates[coordinates.length - 1];

    var endMarker;

    startMarker = this.createMarker(

      [coordinates[0].fLon, coordinates[0].fLat],

      data.strIconName ? `../../../assets/mobile-icons/${data.strIconName}` : `../../../assets/mobile-icons/${data.strURL}`,

      `${routeId}_start`,

      `route_start`

    );

    endMarker = this.craeteArrowTxt(

      [lastCoordinate.fLon, lastCoordinate.fLat],

      `${routeId}_end`,

      `route_end`,

      {
        html: `<div id="" class="pointer">

                  <h5 class='text-dark'>${data.strFullName} (${data.strMobileType_strComment}) </h5>

                  <hr class='text-dark m-1' />

                  <div class='justify-content-end d-flex align-items-center'>

                      <span class=" text-secondary ms-1"> ${data.fLastKM.toLocaleString()} کیلو متر </span>

                      <i class="fa fa-tachometer text-secondary "></i>

                  </div>

                  <div class='justify-content-end d-flex align-items-center'>

                      <span class=" text-secondary ms-1">${data.strVehicleNo}</span>

                      <i class="fa fa-square-o text-secondary "></i>

                  </div>

                  <div class='justify-content-end d-flex align-items-center'>

                      <span class=" text-secondary ms-1">${data.strTime}</span>

                      <i class="fa fa-clock-o text-secondary "></i>

                  </div>

                  <div class='justify-content-end d-flex align-items-center'>

                      <span class=" text-secondary ms-1">${data.strDate}</span>

                      <i class="fa fa-calendar-o text-secondary "></i>

                  </div>

                  <div class='justify-content-end d-flex align-items-center'>

                      <span class=" text-secondary ms-1">${data.strDeviceStatus_strComment}</span>

                      <i class="fa fa-key text-secondary py-2"></i>

                  </div>

                  <a class='btn btn-info w-100' href=${'carInfo/' + data.strUnitID} target="_blank"> جزییات کامل </a>

               </div>`,

        html2: `<span class="text-success p-2 rounded">${lastCoordinate.carName}</span>`,

      },

      lastCoordinate.carName,

      data?.Status

      // ? data.Status : Math.floor(Math.random() * 3)

    );

    var points = [];

    for (const point of coordinates) {

      let coord4326 = olProj.transform(

        [point.fLon, point.fLat],

        "EPSG:4326",

        "EPSG:3857"
      );

      points.push([coord4326[0], coord4326[1]]);

    }

    map.addLayer(startMarker);

    map.addLayer(endMarker);

    return { l1: length };

  }

  removeMarkerById(id: any, map: any) {

    let layers = map.getLayers().getArray().filter((l: any) => {

      l.values_.id == id

    });

    for (const item of layers) {

      map.removeLayer(item);

    }

  }

  //? پاک کردن آیکون با استفاده از شناسه 

  removeMarkerById_New(id: any, map: any) {

    let layers = map.getLayers().getArray().filter((l: any) => {

      return l.values_.id == id

    });


    for (const item of layers) {

      map.removeLayer(item);

    }

  }

  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      animation: true,
      trigger: 'manual',
      placement: 'top',
      html: true,
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        tooltip
          .attr(
            'data-bs-original-title',
            item.featureLayer.feature.get('data').html
          )
          .tooltip('show');
      }
    } else {
      tooltip.tooltip('hide');
    }
  }

  drawRouteFull(routeId: any, map: any, coordinates: any, data: any, hasRandomcolorLine = false, drawLine: boolean = true) {

    var color = Math.floor(Math.random() * 16777215).toString(16);

    var startMarker = this.createMarker([coordinates[0].fLon, coordinates[0].fLat], "../../assets/Img/marker4.png", `${routeId}_start`, `route_start`, {

      html: `<span class="text-success">زمان : ${coordinates[0].strTime}</span>

           <br />

           <span class="text-danger">سرعت : ${coordinates[0].iSpeed}</span>

           `,
    },
    );

    var lastCoordinate = coordinates[coordinates.length - 1];

    var endMarker = this.createMarker(
      [lastCoordinate.fLon, lastCoordinate.fLat],
      "../../assets/Img/marker5.png",
      `${routeId}_end`,
      `route_end`,
      {
        html: `<span class="text-success">زمان : ${lastCoordinate.strTime}</span>
           <br />
           <span class="text-danger">سرعت : ${lastCoordinate.iSpeed}</span>
           `,
      },
    );

    var points = [];

    var pointFeatures = [];

    for (const point of coordinates) {
      let coord4326 = olProj.transform(
        [point.fLon, point.fLat],
        "EPSG:4326",
        "EPSG:3857"
      );
      points.push([coord4326[0], coord4326[1]]);
      var f = new Feature({
        geometry: new Circle([coord4326[0], coord4326[1]], 0),
        data: point.tooltipContent,
        name: "route_point",
      });

      f.setStyle(
        new Style({
          fill: new Fill({
            color: !hasRandomcolorLine ? "#1010fd" : `#${color}`,
          }),
        })
      ); pointFeatures.push(f);
    }

    if (drawLine) {

      var line = new LineString(points);

      var length = getLength(line);

      var style = new Style({
        stroke: new Stroke({
          color: !hasRandomcolorLine ? "#0000ff" : `#${color}`,
          width: 3,
        }),

      });

      var lineFeature = new Feature({
        geometry: line,
        //style: style
      });

      lineFeature.setStyle(style);

      var lineLayer = new VectorLayer({
        source: new VectorSource({
          features: [lineFeature, ...pointFeatures],
        }),
        id: routeId,
        name: "route_line",
      } as any);

      map.addLayer(lineLayer);

    }

    map.addLayer(startMarker);

    map.addLayer(endMarker);

    return { l1: length || 0 };

  }

  craeteArrow(position: any, icon: any, id = '', name = '', data = {}, Rotation: any, drawAngle: boolean = true) {

    if (!drawAngle) return null;

    let coord4326 = olProj.transform(position, 'EPSG:4326', 'EPSG:3857');

    let feature = new Feature({
      type: 'removable',
      geometry: new Point(coord4326),
      data: data,
    });

    var layerImage = new Icon({
      src: icon,
      anchor: [0.59, 10],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      rotation: Math.PI * Rotation / 180,

    });

    let pinLayer = new VectorLayer({
      source: new VectorSource({
        features: [feature],
      }),
      id: id,
      name: name,
      style: new Style({
        image: layerImage,
      }),
    } as any);

    return pinLayer;

  }

  craeteArrowTxt(position: any, id = '', name = '', data = {}, txt: any, iLiveStatus?: number) {

    let coord4326 = olProj.transform(position, 'EPSG:4326', 'EPSG:3857');

    let feature = new Feature({
      type: 'removable',
      geometry: new Point(coord4326),
      data: data,
    });

    let pinLayer = new VectorLayer({

      source: new VectorSource({
        features: [feature],
      }),

      id: id,

      name: name,

      style: new Style({

        text: new Text({

          text: txt,

          font: '10px Vazir',

          padding: [1, 7, 1, 7],

          scale: 1.5,

          backgroundFill: new Fill({

            color: iLiveStatus == 0 ? '#fecdd3' : iLiveStatus == 1 ? '#bbf7d0' : iLiveStatus == 2 ? '#bfdbfe' : "#fff"

          }),

          fill: new Fill({

            color: "#000",

          }),

        })

      }),


    } as any);

    return pinLayer;
  }

  removeLayerByName(name: any, map: any) {

    let layers = map.getLayers().getArray().filter((l: any) => l.values_.name == name);

    for (const item of layers) {

      map.removeLayer(item);

    }

  }

  getPdf = async (map: any) => {
    this.otherService.Showspinner();
    document.body.style.cursor = 'progress';

    const format = "a3";
    const resolution = 300;
    const dim = [297, 210] as any;
    const width = Math.round((dim[0] * resolution) / 25.4);
    const height = Math.round((dim[1] * resolution) / 25.4);
    const size = map.getSize();
    const viewResolution = map.getView().getResolution();

    map.once('rendercomplete', async () => {
      const mapCanvas = document.createElement('canvas');
      mapCanvas.width = width;
      mapCanvas.height = height;
      const mapContext = mapCanvas.getContext('2d') as any;
      Array.prototype.forEach.call(
        document.querySelectorAll('.ol-layer canvas'),
        function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            // Get the transform parameters from the style's transform matrix
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(
              mapContext,
              matrix
            );
            mapContext.drawImage(canvas, 0, 0);
          }
        }
      );
      mapContext.globalAlpha = 1;
      const pdf = new jspdf('landscape', undefined, format);
      pdf.addImage(
        mapCanvas.toDataURL('image/jpeg'),
        'JPEG',
        0,
        0,
        dim[0],
        dim[1]
      );
      this.otherService.nonespinner();
      await pdf.save('map.pdf');

      // Reset original map size

      map.setSize(size);
      map.getView().setResolution(viewResolution);

      document.body.style.cursor = 'auto';
    });

    // Set print size
    const printSize = [width, height];
    map.setSize(printSize);
    const scaling = Math.min(width / size[0], height / size[1]);
    map.getView().setResolution(viewResolution / scaling);
  }

  drawPolygan = async (map: any, polygonId: any, polyganData: any) => {

    if (!polyganData) {
      var model = {
        iGeoFence: polygonId,

        strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
        iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      };
      const resp = await axios.post(`Radyab_GeoAFence`, model);
      //var data=resp.data;
      this.polyganData = JSON.parse(resp.data);
    }




    var ring = [];
    if (this.polyganData.length != 0) {
      var loc = this.polyganData.lstPoints;
      for (let index = 0; index < loc.length; index++) {
        ring.push([loc[index].fLon, loc[index].fLat]);
      }
      var polygon = new Polygon([ring]);
      polygon.transform('EPSG:4326', 'EPSG:3857');
      var feature = new Feature(polygon);
      var vectorSource = new VectorSource();
      vectorSource.addFeature(feature);
      var vectorLayer = new VectorLayer({
        source: vectorSource,
        name: 'polygon',
        style: new Style({
          stroke: new Stroke({
            color: 'red',
            width: 4,
            lineDash: [10, 20, 10, 20]
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0)'
          })
        }),
      } as any);
      map.addLayer(vectorLayer);
      this.fitMap(this.polyganData.lstPoints, map)
      return this.polyganData;

    }
  }

  fitMap(data: any, map: any) {

    //remove car not have Location

    data = data.filter(function (el: any) {
      return el.fLon != 0;
    });

    var maxLatitude = Math.max.apply(
      Math,
      data.map(function (o: any) {
        return o.fLat;
      })
    );

    var maxLongitude = Math.max.apply(
      Math,
      data.map(function (o: any) {
        return o.fLon;
      })
    );

    var minLatitude = Math.min.apply(
      Math,
      data.map(function (o: any) {
        return o.fLat;
      })
    );

    var minLongitude = Math.min.apply(
      Math,
      data.map(function (o: any) {
        return o.fLon;
      })
    );

    var view = map.getView();

    var transformedStart = this.transformCoordinates2([

      maxLongitude,

      maxLatitude,

    ]);

    var transformedEnd = this.transformCoordinates2([
      minLongitude,

      minLatitude,

    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 6000,
      Math.min(transformedStart[1], transformedEnd[1]) - 6000,
      Math.max(transformedStart[0], transformedEnd[0]) + 6000,
      Math.max(transformedStart[1], transformedEnd[1]) + 6000,
    ];

    view.fit(source);

    if (data.length == 1) {
      map.getView().setZoom(17);
    }

  }

}
